<template>
    <div>
        <pet-title-component :title="name"></pet-title-component>
        <div class="card-content">
            <div class="row">
                <div class="col">
                    <b-form-group id="name-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.name')"
                                  label-for="name-input">
                        <b-form-input id="name-input"
                                      class="o-form"
                                      type="text"
                                      v-model="name"
                                      placeholder="">
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="species-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.species')"
                                  label-for="species-input">
                        <b-form-input id="species-input"
                                      class="o-form"
                                      type="text"
                                      v-model="species"
                                      placeholder="">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="transponder-id-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.transponderId')"
                                  label-for="transponder-id-input">
                        <b-form-input id="transponder-id-input"
                                      class="o-form"
                                      type="text"
                                      v-model="transponderId"
                                      placeholder="">
                        </b-form-input>
                    </b-form-group>
                </div>
                <div class="col">
                    <b-form-group id="birthdate-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.birthdate')"
                                  label-for="birthdate-input">
                        <datepicker v-model="birthdate" id="birthdate-input" class="o-form" :format="'dd.MM.yyyy'"></datepicker>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="veterinarian-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.veterinarian')"
                                  label-for="veterinarian-input">
                        <b-form-input id="veterinarian-input"
                                      class="o-form"
                                      type="text"
                                      v-model="veterinarian"
                                      placeholder="">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="custody-after-death-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.custody')"
                                  label-for="custody-after-death-input">
                        <b-form-input id="custody-after-death-input"
                                      class="o-form"
                                      type="text"
                                      v-model="custodyAfterDeath"
                                      placeholder="">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-form-group id="notes-form-group"
                                  class="o-label"
                                  :label="$t('pets.pet.notes')"
                                  label-for="notes-input">
                        <b-form-input id="notes-input"
                                      class="o-form"
                                      type="text"
                                      v-model="notes"
                                      placeholder="">
                        </b-form-input>
                    </b-form-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import PetTitleComponent from '../shared/FileTitleComponent'
    import Datepicker from 'vuejs-datepicker'

    export default {
        name: 'AllInfoPet',
        components: {
            'card-title-component': CardTitleComponent,
            'pet-title-component': PetTitleComponent,
            'datepicker': Datepicker
        },
        props: ['name', 'species', 'transponderId', 'birthdate', 'veterinarian', 'custodyAfterDeath', 'notes']
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guardian/AllInfoPetComponent.vue